import { render, staticRenderFns } from "./addApplyRoomDiscountList.vue?vue&type=template&id=5ff02aa8&scoped=true"
import script from "./addApplyRoomDiscountList.vue?vue&type=script&lang=js"
export * from "./addApplyRoomDiscountList.vue?vue&type=script&lang=js"
import style0 from "./addApplyRoomDiscountList.vue?vue&type=style&index=0&id=5ff02aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff02aa8",
  null
  
)

export default component.exports